import type { ChecklistRow, ChecklistRowsByCategory, WithChecklistItemMetadata } from './types';

export type GeneratedChecklistRow = WithChecklistItemMetadata<ChecklistRow>;

export function getAllChecklistRows(rows: ChecklistRowsByCategory): Array<GeneratedChecklistRow> {
  return [
    ...rows.setupRows,
    ...rows.campaignRows,
    ...rows.discountsMarginRows,
    ...rows.marginRows,
    ...rows.capacityRows,
    ...rows.dealOptionsInclusionsRows,
    ...rows.dealOptionApprovalRows,
    ...rows.surchargeTableRows,
    ...rows.baseSurchargesRows,
    ...rows.blackoutRows,
    ...rows.bundledExperienceRows,
    ...rows.taxesPaymentsRows,
  ];
}
